<div *ngIf="isLoading" class="loading-overlay">
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
</div>

<div class="container py-3" style="max-width: 1020px">
  <div class="row">
    <div class="col-md-8 mb-3">
      <mat-card class="p-4" style="max-width: 650px">
        <mat-card-title
          *ngIf="true"
          mat-dialog-title
          class="d-flex align-items-center mb-0"
        >
          <mat-icon class="mr-2">laptop</mat-icon>
          &nbsp;
          <div *ngIf="!isEdit">
            {{ 'inventory.add-edit.add-title' | translate }}
          </div>
          <div *ngIf="isEdit">
            {{ 'inventory.add-edit.edit-title' | translate }}
          </div>
        </mat-card-title>
        <mat-card-subtitle>
          <div *ngIf="!isEdit">
            {{ 'inventory.add-edit.add-subtitle' | translate }}
          </div>
          <div *ngIf="isEdit">
            {{ 'inventory.add-edit.edit-subtitle' | translate }}
          </div>
        </mat-card-subtitle>

        <mat-divider></mat-divider>

        <mat-card-content>
          <form [formGroup]="addEditInventoryFormGroup">
            <div class="row">
              <div class="col mt-4"></div>
            </div>

            <div class="row">
              <div class="col">
                <mat-form-field appearance="fill" style="width: 100%">
                  <mat-label>{{
                    'inventory.add-edit.form.category' | translate
                  }}</mat-label>
                  <input
                    [disabled]="isView"
                    type="text"
                    placeholder="{{
                      'inventory.add-edit.form.category' | translate
                    }}"
                    matInput
                    formControlName="category"
                    id="category"
                    [matAutocomplete]="auto"
                  />
                  <mat-icon matSuffix class="custom-arrow-icon">
                    arrow_drop_down
                  </mat-icon>
                  <mat-autocomplete
                    autoActiveFirstOption
                    #auto="matAutocomplete"
                    (optionSelected)="setCategoryData($event.option.value)"
                  >
                    <!-- <mat-select formControlName="category"> -->
                    <mat-option
                      *ngFor="let category of filteredCategoryList"
                      [value]="category.displayValue"
                      required
                    >
                      {{ category.displayValue }}
                    </mat-option>
                  </mat-autocomplete>

                  <mat-error
                    *ngIf="
                      addEditInventoryFormGroup.controls.category.hasError(
                        'required'
                      ) && addEditInventoryFormGroup.controls.category.touched
                    "
                  >
                    {{
                      'inventory.add-edit.form.required.category' | translate
                    }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <mat-form-field
                  appearance="fill"
                  style="width: 100%"
                  hintLabel=" "
                >
                  <mat-label>{{
                    'inventory.add-edit.form.asset-id' | translate
                  }}</mat-label>
                  <input
                    type="text"
                    #titleField
                    matInput
                    maxlength="50"
                    placeholder="{{
                      'inventory.add-edit.form.asset-id-placeholder' | translate
                    }}"
                    formControlName="assetId"
                    required
                  />
                  <mat-error>{{
                    'inventory.add-edit.form.required.asset-id' | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <!-- serial Number -->

            <div class="row">
              <div class="col">
                <mat-form-field appearance="fill">
                  <mat-label>
                    {{ 'inventory.add-edit.form.serial-number' | translate }}
                  </mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="serialNumber"
                    [placeholder]="
                      translate.instant(
                        'inventory.add-edit.form.serial-number-placeholder'
                      )
                    "
                    required
                    maxlength="50"
                  />
                  <mat-error>{{
                    'inventory.add-edit.form.required.serial-number' | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <mat-form-field appearance="fill">
                  <mat-label>
                    {{ 'inventory.add-edit.form.manufacturer' | translate }}
                  </mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="manufacture"
                    [placeholder]="
                      translate.instant(
                        'inventory.add-edit.form.manufacturer-placeholder'
                      )
                    "
                    required
                    maxlength="50"
                  />
                  <mat-error>{{
                    'inventory.add-edit.form.required.manufacture' | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <mat-form-field appearance="fill">
                  <mat-label>
                    {{ 'inventory.add-edit.form.vendor' | translate }}
                  </mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="vendor"
                    [placeholder]="
                      translate.instant(
                        'inventory.add-edit.form.vendor-placeholder'
                      )
                    "
                    required
                    maxlength="50"
                  />
                  <mat-error>{{
                    'inventory.add-edit.form.required.vendor' | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <mat-form-field appearance="fill">
                  <mat-label>
                    {{ 'inventory.add-edit.form.model' | translate }}
                  </mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="model"
                    [placeholder]="
                      translate.instant(
                        'inventory.add-edit.form.model-placeholder'
                      )
                    "
                    required
                    maxlength="50"
                  />
                  <mat-error>{{
                    'inventory.add-edit.form.required.model' | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <!-- warranty date -->

            <div class="row">
              <div class="col">
                <mat-form-field appearance="fill" style="width: 100%">
                  <mat-label>{{
                    'inventory.add-edit.form.purchase-date' | translate
                  }}</mat-label>
                  <input
                    data-testid="notices_add_notice_input_start_date"
                    placeholder="{{
                      'inventory.add-edit.form.purchase-date' | translate
                    }}"
                    type="text"
                    matInput
                    formControlName="purchase_date"
                    [matDatepicker]="pickerA"
                    (click)="pickerA.open()"
                    required
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerA"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerA></mat-datepicker>
                  <mat-error>{{
                    'inventory.add-edit.form.required.purchase-date' | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <mat-form-field appearance="fill" style="width: 100%">
                  <mat-label>{{
                    'inventory.add-edit.form.warranty-end-in' | translate
                  }}</mat-label>
                  <input
                    data-testid="notices_add_notice_input_end_date"
                    type="text"
                    placeholder="{{
                      'inventory.add-edit.form.warranty-end-in' | translate
                    }}"
                    matInput
                    formControlName="warranty_end_date"
                    [min]="
                      addEditInventoryFormGroup.controls.purchase_date.value
                    "
                    [matDatepicker]="pickerB"
                    (click)="pickerB.open()"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerB"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerB></mat-datepicker>
                  <mat-error>
                    {{ 'inventory.add-edit.form.warranty-end-in' | translate }}
                    {{
                      'inventory.add-edit.form.required.error-date' | translate
                    }}
                    {{ 'inventory.add-edit.form.purchase-date' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <mat-form-field appearance="fill" style="width: 100%">
                  <mat-label>
                    {{ 'inventory.add-edit.form.description' | translate }}
                  </mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="description"
                    placeholder="{{
                      'inventory.add-edit.form.description-placeholder'
                        | translate
                    }}"
                    #description
                    maxlength="400"
                  />
                  <mat-hint align="end"
                    >{{ description.value?.length || 0 }}/400
                    {{ 'articles.add-article.characters' | translate }}
                  </mat-hint>
                </mat-form-field>
              </div>
            </div>

            <!-- Image -->

            <div class="row mt-4">
              <div class="col">
                <mat-divider></mat-divider>
                <app-drag-and-drop
                  style="width: 100%"
                  [allowUpload]="true"
                  [allowDelete]="false"
                  [uploadDirectly]="false"
                  [displayImg]="true"
                  (triggerFileSelected)="triggerFileSelected($event)"
                  [showUploadedFiles]="false"
                  [allowedTypesNames]="allowedTypesNames"
                  [allowedTypesRegex]="allowedTypesRegex"
                  [maxSize]="20"
                  [remainingFilesCount]="100"
                  [remainingFiles]="false"
                  required
                >
                </app-drag-and-drop>
              </div>
              <mat-divider></mat-divider>
            </div>

            <div class="row" *ngIf="documentsDataList.length > 0">
              <div class="col">
                <app-display-data-in-dlt
                  [totalCount]="documentsDataList.length"
                  [dataListArray]="documentsDataList"
                  (onClickAction)="action($event)"
                >
                </app-display-data-in-dlt>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-md-12 d-flex justify-content-end">
                <button
                  *ngIf="!isEdit"
                  mat-flat-button
                  color="primary"
                  (click)="onSave()"
                  [disabled]="this.addEditInventoryFormGroup.invalid"
                >
                  {{ 'inventory.add-edit.form.save' | translate }}
                </button>
                <button
                  *ngIf="isEdit"
                  mat-flat-button
                  color="primary"
                  (click)="onUpdate()"
                  [disabled]="
                    addEditInventoryFormGroup.invalid ||
                    addEditInventoryFormGroup.pristine
                  "
                >
                  {{ 'inventory.add-edit.form.update' | translate }}
                </button>
              </div>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>

    <!--Help and Support (START)-->
    <div class="col-md-4 mb-3">
      <mat-card style="height: fit-content">
        <mat-card-header>
          <mat-card-title>
            <h6>
              <mat-icon class="heading-icon mr-2">help</mat-icon>&nbsp;
              {{ 'inventory.add-edit.help-and-support.title' | translate }}
            </h6>
            <p style="font-weight: lighter; font-size: small; color: grey">
              {{ 'inventory.add-edit.help-and-support.subtitle' | translate }}
            </p>
          </mat-card-title>
        </mat-card-header>

        <mat-divider></mat-divider>
        <mat-card-content>
          <div class="mt-2 pt-2">
            <mat-accordion [multi]="true">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="d-flex align-items-center">
                    <mat-icon class="heading-icon mr-2"> laptop </mat-icon>
                    {{
                      'inventory.add-edit.help-and-support.card-1.title'
                        | translate
                    }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                {{
                  'inventory.add-edit.help-and-support.card-1.content'
                    | translate
                }}
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <!--Help and Support (END)-->
  </div>
</div>
